import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/site/Reveal";
import { PricingOptions } from "@/components/site/PricingOptions";
import { useShop } from "@/lib/shop";
import { Price } from "@/components/site/Price";
import { useSeo } from "@/lib/useSeo";
import { pageSchema } from "@/lib/schema";

const Tile = ({ p, className = "", featured }) => (
  <Link to={`/products/${p.role}`} data-testid={`collection-${p.role}`}
    className={`group relative flex h-full flex-col overflow-hidden border bg-[#0b0b0b] ${featured ? "border-cta" : "border-line"} ${className}`}>
    <div className="relative flex-1 overflow-hidden">
      <img src={p.image} alt={p.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
    </div>
    <div className="flex items-end justify-between gap-4 border-t border-line p-6">
      <div>
        <p className="eyebrow">{p.kind}{featured && " · Recommended"}</p>
        <p className="font-display mt-2 text-xl text-white">{p.name}</p>
      </div>
      <div className="text-right">
        <p className="font-display text-xl text-white"><Price role={p.role} /></p>
        <ArrowUpRight size={18} className="ml-auto mt-1 text-white transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
      </div>
    </div>
  </Link>
);

export default function Products() {
  const { products } = useShop();
  useSeo("Products", "The First Mover Method eBook, the Workbook and the complete Bundle.",
    pageSchema("CollectionPage", "Products", "/products", "The First Mover Method eBook, the Workbook and the complete Bundle."));
  return (
    <main data-testid="products-page" className="pt-28 md:pt-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <p className="eyebrow">The collection</p>
        <h1 className="font-display mt-5 text-5xl font-medium tracking-tight text-white md:text-7xl">
          <MaskedLines lines={["Two products.", <span key="l" className="font-serif-i text-zinc-400">One system.</span>]} />
        </h1>
        <div className="mt-16 grid gap-6 md:h-[680px] md:grid-cols-12 md:grid-rows-2">
          <Reveal className="h-[440px] md:col-span-7 md:row-span-2 md:h-full"><Tile p={products.bundle} featured /></Reveal>
          <Reveal delay={0.08} className="h-[360px] md:col-span-5 md:h-full"><Tile p={products.ebook} /></Reveal>
          <Reveal delay={0.16} className="h-[360px] md:col-span-5 md:h-full"><Tile p={products.workbook} /></Reveal>
        </div>
      </div>
      <section className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-36">
        <h2 className="font-display mb-14 text-3xl font-medium tracking-tight text-white md:text-5xl">Compare and choose.</h2>
        <PricingOptions />
      </section>
    </main>
  );
}
